import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const centerDynamicModalConfig: DynamicDialogConfig = {
  closable: false,
  showHeader: false,
  closeOnEscape: true,
  appendTo: 'body',
  width: '705px',
  breakpoints: {
    '705px': '100vw',
  },
  baseZIndex: 10000,
};



export const rightDynamicModalConfig: DynamicDialogConfig = {
  closable: false,
  showHeader: false,
  closeOnEscape: true,
  appendTo: 'body',
  position: 'right',
  width: '968px',
  height: '100vh',
  breakpoints: {
    '968px': '100vw',
  },
  baseZIndex: 10000,
};
